// config.js

const bizIcon = "https://static.wixstatic.com/media/e3a047_0c2f1c3bac7c49bb8890d543dcd336dd~mv2.jpg/v1/fill/w_377,h_142,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Screenshot%20(69)_edited.jpg";
const imageOne = "https://media.istockphoto.com/id/1300800419/photo/miami-beach-ocean-drive-historic-district.jpg?s=612x612&w=0&k=20&c=EszsFRCY6PHnpWGF2RMF0gegJ9ZX2u8-WI2OZsxyb9I=";
const imageTwo = "https://media.istockphoto.com/id/492725842/photo/new-construction-townhomes.jpg?s=612x612&w=0&k=20&c=Kuf7LB4E0sTMig3XXVRikhOjrEX5TZa685hlGMsp5-4=";
const imageThree = "https://media.istockphoto.com/id/526233437/photo/ocean-drive.jpg?s=612x612&w=0&k=20&c=chhrIe4an3Bi5yk1BJSqCO_wPNN6CcWtBanDPISoBwg=";
const imageFour = "https://media.istockphoto.com/id/172291166/photo/art-deco-on-ocean-drive.jpg?s=612x612&w=0&k=20&c=n4lf-4HXtx4toFfl91GbZyHi4tvrj1EpdWVvcaX3spI=";
const imageFive = "https://media.istockphoto.com/id/674221714/photo/pompano-beach-and-fort-lauderdale-area-from-above.jpg?s=612x612&w=0&k=20&c=luvII2lQxistr2hsYqa2MfZi8IURdV1ZJhS40AA28J0=";

const socialMediaLink = 'https://www.paintingandhandyman.com/';

export const siteConfig = {
  title: "Family Home Constructions",
  metaDescription: "Family Home Constructions",
  theme: {
    primaryColor: "teal-500",
    secondaryColor: "gray-200",
    accentColor: "text-teal-500"
  },
  logo: {
    src: bizIcon,
    alt: "Family Home Constructions",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Family Home Constructions",
    headline: "Exceptional Painting Service",
    address: "Englewood, Florida, United States",
    description: "Quality painting services for your lovely home."
  },
  images: {
    business: {
      src: imageOne,
      alt: "Premium Painting Services",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      description:
        "Transform your home or business with Family Home Constructions' expert painting services. From vibrant interiors to durable exteriors, we bring life back to your property with professional, high-quality results.",
    },
    {
      description:
        "With years of experience in residential and commercial painting, our skilled team ensures perfection, punctuality, and attention to detail in every project. Your satisfaction is our top priority.",
    },
    {
      description:
        "Whether it's kitchen cabinets, decks, or trim, Family Home Constructions provides tailored solutions to meet your unique painting needs. We build trust through integrity, reliability, and exceptional service.",
    },
  ],
  services: {
    sectionTitle: "Our Services",
    description: "At Family Home Constructions, we specialize in painting services that make a lasting impression. From revitalizing your home's interior to enhancing your business's exterior, we bring fresh color and life to your spaces. With a commitment to quality, professionalism, and customer satisfaction, we deliver exceptional results tailored to your unique needs. Let us help you add value and beauty to your property today.",
    callouts: [
      {
        name: 'Residential Painting',
        description: "Enhance your home's charm with expert interior and exterior painting services. We ensure flawless finishes and vibrant colors that last."        ,
        imageSrc: imageTwo,
        imageAlt: 'Beautifully painted home exterior',
      },
      {
        name: 'Commercial Painting',
        description: "Make your business stand out with professional painting services designed to create a welcoming and professional appearance.",
        imageSrc: imageThree,
        imageAlt: 'Modern commercial building with a fresh coat of paint',
      },
      {
        name: 'Exterior & Interior Painting',
        description: "From refreshing interiors to weatherproofing exteriors, our skilled team provides expert painting solutions for every surface.",
        imageSrc: imageFour,
        imageAlt: 'Elegant living room with freshly painted walls',
      }
    ],
    otherServices: [
      "Dock & Deck Painting",
      "Kitchen Cabinets Painting",
      "Time & Molding Painting"
    ]
  },  
  about: {
    sectionTitle: "About Us",
    description: "At Family Home Constructions, we pride ourselves on delivering exceptional painting services to the Englewood community and beyond. With a dedication to perfection, punctuality, and professionalism, we strive to exceed your expectations in every project. Built on a foundation of trust, integrity, and reliability, our team ensures beautiful, long-lasting results that enhance the value and aesthetics of your property. Let us help bring your vision to life with our expert painting solutions.",
    image: {
      src: imageFive,
      alt: "Family Home Constructions painting team in action",
      width: 2432,
      height: 1442
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "Englewood, Florida, United States",
    googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3446.091801544223!2d-82.3609237!3d26.962006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88dcf1f8e4ddbe1f%3A0xb2aafecf49508d26!2sEnglewood%2C%20FL%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: 'https://maps.apple.com/?address=Englewood,%20FL&ll=26.962006,-82.3609237&q=Englewood,%20FL',
      },
      { 
        name: 'Bing Maps', 
        url: 'https://www.bing.com/maps?q=Englewood,+FL&FORM=HDRSC6',
      },
      { 
        name: 'Google Earth', 
        url: 'https://earth.google.com/web/search/Englewood,+FL/@26.962006,-82.3609237,15a,814.57589625d,35y,0h,0t,0r',
      },
      { 
        name: 'Google Maps', 
        url: 'https://www.google.com/maps/place/Englewood,+FL/@26.962006,-82.3609237,17z',
      }
    ]
  },  
  contact: {
    sectionTitle: "Schedule a Free Consultation for Your Painting Needs",
    description:     "Ready to transform your home or business with top-quality painting services? Contact Family Home Constructions today to schedule a free consultation. Let our experienced team bring your vision to life with expert craftsmanship and reliable service you can trust.",
    socialLinks: {
      facebook: socialMediaLink,
      instagram: socialMediaLink,
      twitter: socialMediaLink,
      youtube: socialMediaLink,
      tiktok: socialMediaLink
    },
    contactNumbers: ["941-536-7673"],
    logo: bizIcon,
    emailRecipient: "luisorbea97@hotmail.com"
  },
  footer: {
    bizSolutionsLogo: "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg"
  }
};
